import createTableStore from "ds/components/Table/store/useTableStore";

import { BACKSTAGE_TABLE_COLUMNS_CONFIG, BACKSTAGE_TABLE_STORAGE_KEY } from "./constants";

const useBackstageTableStore = createTableStore({
  storageKey: BACKSTAGE_TABLE_STORAGE_KEY,
  config: BACKSTAGE_TABLE_COLUMNS_CONFIG,
});

export default useBackstageTableStore;
